import API from '../dataApi';

// -- Accounting: Reports -------------------------------------------------------
export const getBalanceSheet = (params) => API.get('/reports/balance-sheet', { params });
export const getTrialBalance = (params) => API.get('/reports/trial-balance', { params });
export const getIncomeExpenditure = (params) => API.get('/reports/income-expenditure', { params });
export const getAccountLedger  = (params) => API.get('/reports/account-ledger',  { params });
export const getLedgerSummary  = (params) => API.get('/reports/ledger-summary',   { params });
export const getCategoryFund = (params) => API.get('/reports/category-fund', { params });
export const getUserLedger = (userId, params) => API.get(`/reports/user-ledger/${userId}`, { params });
export const getOfferingsReport = (params) => API.get('/reports/offerings', { params });
export const getMyOfferingsReport = (params) => API.get('/reports/my-offerings', { params });
export const getPledgeAging = (params) => API.get('/reports/pledge-aging', { params });
export const getDayBook = (params) => API.get('/reports/day-book', { params });
export const getCashBook = (params) => API.get('/reports/cash-book', { params });
export const getBankBook = (params) => API.get('/reports/bank-book', { params });
export const getAccGoldRegister = (params) => API.get('/reports/gold-register', { params });
export const getOBReport = (yearId) => API.get(`/reports/opening-balance/${yearId}`);
export const getAmendmentHistory = (yearId) => API.get(`/reports/amendments/${yearId}`);
export const downloadReportPdf = (reportType, params) =>
  API.get(`/reports/pdf/${reportType}`, { params, responseType: 'blob' });
export const exportReportTable = (data) =>
  API.post('/reports/export-table', data, { responseType: 'blob' });
export const renderReportPdf = (payload) =>
  API.post('/pdf-render', payload, { responseType: 'blob' });
export const sendMemberReportEmail = (data) => API.post('/reports/member-report-email', data);
export const emailReportPdf = (data) => API.post('/reports/email-pdf', data);
export const emailExcelReport = (data) => API.post('/reports/email-excel', data);
